function toggleMobileMenu() {
  const menu = document.getElementById('mobile-menu-dropdown');
  menu.classList.toggle('open');

  document.addEventListener(
    'click',
    function (e) {
      if (!e.target.closest('.ind-mobile-menu-wrapper')) {
        menu.classList.remove('open');
      }
    },
    { once: true }
  );
}

(function ensureHeaderSticky() {
  var wrapper = document.querySelector('[data-ind-header]');
  if (!wrapper || wrapper.classList.contains('ind-header-no-sticky')) return;
  if (document.documentElement.classList.contains('has-byb-hero')) return;
  var section = wrapper.closest('.shopify-section');
  if (section) {
    section.style.position = 'sticky';
    section.style.top = '0';
    section.style.zIndex = '1000';
  }
})();

/**
 * Transparent-over-hero modifier.
 * Activates only when a hero marks itself with [data-byb-hero]
 * (do not hardcode homepage). Solid is the default everywhere else.
 */
(function headerTransparentOverHero() {
  var header = document.querySelector('[data-ind-header]');
  if (!header || header.classList.contains('ind-header-no-sticky')) return;

  var hero = document.querySelector('[data-byb-hero]');
  if (!hero) return;

  document.documentElement.classList.add('has-byb-hero');
  header.classList.add('ind-header--over-hero');

  var SCROLL_THRESHOLD = 24;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var ticking = false;

  function setSolid(isSolid) {
    header.classList.toggle('ind-header--solid', isSolid);
    header.classList.toggle('ind-header--transparent', !isSolid);
  }

  function updateFromScroll() {
    var y = window.scrollY || window.pageYOffset;
    setSolid(y > SCROLL_THRESHOLD);
    ticking = false;
  }

  function onScroll() {
    if (reducedMotion.matches) {
      updateFromScroll();
      return;
    }
    if (!ticking) {
      requestAnimationFrame(updateFromScroll);
      ticking = true;
    }
  }

  setSolid((window.scrollY || window.pageYOffset) > SCROLL_THRESHOLD);
  window.addEventListener('scroll', onScroll, { passive: true });
})();

(function headerHideOnScroll() {
  var header = document.querySelector('[data-ind-header]');
  if (!header || header.classList.contains('ind-header-no-sticky')) return;
  // Hero pages use transparent/solid swap instead of hide-on-scroll
  if (header.classList.contains('ind-header--over-hero')) return;

  var lastScrollY = window.scrollY || window.pageYOffset;
  var scrollThreshold = 60;
  var ticking = false;

  function updateHeader() {
    var currentScrollY = window.scrollY || window.pageYOffset;
    if (currentScrollY <= scrollThreshold) {
      header.classList.remove('header--hidden');
    } else if (currentScrollY > lastScrollY) {
      header.classList.add('header--hidden');
    } else {
      header.classList.remove('header--hidden');
    }
    lastScrollY = currentScrollY;
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(updateHeader);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
})();

(function scrollToTopButton() {
  var btn = document.getElementById('ind-scroll-to-top-btn');
  if (!btn) return;

  function syncStickyBarFlag() {
    var hasStickyBar = !!(
      document.querySelector('.ind-footer') ||
      document.querySelector('.sp-sticky-bar') ||
      document.querySelector('.cfg-footer')
    );
    document.body.classList.toggle('has-sticky-atc', hasStickyBar);
  }
  syncStickyBarFlag();
  setTimeout(syncStickyBarFlag, 500);
  setTimeout(syncStickyBarFlag, 1500);

  var showThreshold = 300;
  var ticking = false;
  function updateVisibility() {
    var y = window.scrollY || window.pageYOffset;
    var nearBottom =
      window.innerHeight + y >= document.documentElement.scrollHeight - 80;
    if (y > showThreshold && !nearBottom) btn.classList.add('visible');
    else btn.classList.remove('visible');
    ticking = false;
  }
  function onScrollBtn() {
    if (!ticking) {
      requestAnimationFrame(updateVisibility);
      ticking = true;
    }
  }
  window.addEventListener('scroll', onScrollBtn, { passive: true });
  window.addEventListener('resize', onScrollBtn, { passive: true });
  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();
